import { Link } from "react-router-dom";

function Menu( { title, links } ) {
    return( 
        <ul className="menu-section">
            <li className="menu-group-title">
                {title}
            </li>
            <li className="menu-group-links">
                <ul className="menu-group-link-items">
                    { links?.length > 0 && links.map( ( link , index ) => {
                        return(
                            <li key={index} className="link">
                                <Link to={link?.links_to || '/'}>
                                    { link?.icon != null && 
                                        <span className="icon" dangerouslySetInnerHTML={{ __html: link.icon }}>
                                        </span>
                                    }
                                
                                    { link?.title && 
                                        <span className="title">{link.title}</span>
                                    }
                                </Link>
                            </li>
                        )
                        
                    })}
                </ul>
            </li>
        </ul>
    );
}

export default Menu;